module.exports = __webpack_public_path__ + "img/oceanShippingListImg_2.a271647a.jpg";